const AppMedical = () => import('./medical.vue');
const MedicalComponent = () => import('./medical-module/medical-module.vue');
const PortalComponent = () => import('./portal-module/portal-module.vue');
const DentalChart = () => import('../dental/dental-settings/dental-settings.vue');
//const AppMedicalRecords = () => import('../medical-records/medical-records.vue');
//const ItemsOfServicesRouter = () => import('../visit-management/mini-packages/mini-packages-routes.js');

//const ItemsOfServicesList = () => import('../visit-management/mini-packages/mini-packages-list/mini-packages-list.vue');
//const ItemsOfServicesSave = () => import('../visit-management/mini-packages/mini-packages-save/mini-packages-save.vue');


//const PatientMedicalRecords = () => import('../../app/medical-records/patient-medical-records/patient-medical-records.vue');
//const PatientMerge = () => import('../../app/medical-records/patient-medical-records/patient-merge/patient-merge.vue');
//const NewPatientMerge = () => import('../../app/medical-records/patient-medical-records/new-patient-merge/new-patient-merge.vue');

//const CheckEligibility = () => import('@/app/visit-management/authorization/check-eligibility/check-eligibility.vue');





//const DiagnosisSetupComponent = () => import('../patient-problems/setup/diagnosis-setup/diagnosis-setup.vue');

//const DentalChart = () => import('../../../../DentalModule-UI/dental-ui/src/app/dental/dental-settings/dental-chart-settings/dental-chart-settings.vue');


//Guards
import { guardRoute } from '../guardRouter';

//Localization
import localeEn from '../../locales/en'
import localeAr from '../../locales/ar'
const lang = localStorage.getItem('NG_TRANSLATE_LANG_KEY');

export const translation = {
    en: {
        ...localeEn
    },
    ar: {
        ...localeAr
    }
}

//const lang = localStorage.getItem('NG_TRANSLATE_LANG_KEY');


const medicalRoutes = [
    {
        path: '/medical',
        component: AppMedical,
        name: 'app.Medical',
        meta: {
            title: translation[lang].Nav.Medical.Medical
        },
        children: [
            {
                path: 'physician-managment',
                name: 'physician-managment',
                meta: {
                    //title: translation[lang].Nav.Finance.GL
                    title: 'Physician Managment'
                },
                component: PortalComponent,
                children: [
                    {
                        path: 'portal',
                        name: 'portal',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: 'Portal'
                        },
                        component: PortalComponent,
                        children: [
                            {
                                path: 'doctor-desktop',
                                name: 'app.DoctorDesktop.DoctorDesktop.PhysicianManagment',
                                component: PortalComponent,
                                meta: {
                                    title: 'Doctor Desktop',
                                },
                            },  // Doctor Desktop
                        ]
                    }
                ]
            },   // Doctor Desktop
            {
                path: 'administration',
                name: 'administration',
                meta: {
                    title: translation[lang].Nav.Administration.Administration
                },
                component: MedicalComponent,
                children: [
                    {
                        path: 'access-management',
                        name: 'access-management',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: translation[lang].Nav.Administration.AccessManagement
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'user-list',
                                name: 'app.Administration.AccessManagement.UsersList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Administration.UsersList,
                                },
                            }, // User List
                            {
                                path: 'role-list',
                                name: 'app.Administration.AccessManagement.RoleList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Administration.RoleList,
                                },
                            },


                        ]
                    }, // Access Management
                    {
                        path: 'dental-settings',
                        name: 'dental-settings',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: 'Dental Settings'
                        },
                        component: AppMedical,
                        children: [
                            //{
                            //    path: 'dental-chart-settings',
                            //    name: 'app.Dental.Dental.DentalChartSettings',
                            //    component: MedicalComponent,
                            //    meta: {
                            //        title: 'Dental Chart Settings',
                            //    },
                            //}, // Dental Chart Settings
                            {
                                path: 'dental-chart-settings',
                                name: 'app.Dental.Dental.DentalChartSettings',
                                component: AppMedical,
                                meta: {
                                    title: 'Dental Chart Setting',
                                },
                            }, // New Dental Chart Settings
                            {
                                path: 'dental-categories-setup',
                                name: 'app.Dental.Dental.DentalCategoriesList',
                                component: AppMedical,
                                meta: {
                                    title: 'Dental Categories Setup',
                                },
                            }, // Dental Categories list
                            {
                                path: 'dental-procedures-setup',
                                name: 'app.Dental.Dental.DentalProceduresSetup',
                                component: AppMedical,
                                meta: {
                                    title: 'Dental Procedures Setup',
                                },
                            }, // Dental Procedures Setup
                        ]
                    }, // dental-settings
                    {
                        path: 'physician-assignments',
                        name: 'physician-assignments',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: 'Physician Assignments'
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'physician-assignments',
                                name: 'app.PhysicianAssignments.PhysicianAssignments.PhysicianAssignments',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Physician Assignments',
                                },
                            }, // Physician Assignments
                        ]
                    }, // Physician Assignments
                    {
                        path: 'dynamic-forms',
                        name: 'dynamic-forms',
                        meta: {
                            title: translation[lang].Nav.Administration.DynamicForms
                            // title: 'Dynamic Forms'
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'manage-forms',
                                name: 'app.ClinicalSheet.ClinicalSheet.ManageForms',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Administration.ManageLibrary
                                },
                            }, // Manage Forms
                        ]
                    }, // Dynamic Forms

                    // setup
                    {
                        path: 'diagnosis-setting',
                        name: 'app.Administration.DiagnosisSetting',
                        component: MedicalComponent,
                        meta: {
                            title: translation[lang].Nav.Administration.DiagnosisSetting

                        },
                        children: [
                            {
                                path: 'diagnosis-setup',
                                name: 'app.Administration.DiagnosisSetting.DiagnosisSetup',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Administration.DiagnosisSetup,
                                },

                            }
                        ]
                    }

                ]
            },   // Administration
            {
                path: 'new-administration',
                name: 'new-administration',
                meta: {
                    //title: translation[lang].Nav.Finance.GL
                    title: 'Administration'
                },
                component: DentalChart,
                children: [
                    {
                        path: 'dental-settings',
                        name: 'dental-settings',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: 'Dental Settings'
                        },
                        component: DentalChart,
                        children: [
                            {
                                path: 'dental-chart-settings',
                                name: 'app.Dental.Dental.DentalChartSettings',
                                component: DentalChart,
                                meta: {
                                    title: 'Dental Chart Setting',
                                },
                            }, // New Dental Chart Settings
                        ]
                    }
                ],
            },
            {
                path: 'bed-management',
                name: 'bed-management',
                meta: {
                    //title: translation[lang].Nav.Finance.GL
                    title: 'Bed Management'
                },
                component: MedicalComponent,
                children: [
                    {
                        path: 'bed-management',
                        name: 'bed-management',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: 'Bed Management'
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'bed-board',
                                name: 'app.BedManagement.BedManagement.BedManagement',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Bed Board',
                                },
                            },  // Bed Board
                        ]
                    }
                ]
            },   // Bed Management
            {
                path: 'billing-management',
                name: 'billing-management',
                meta: {
                    title: translation[lang].Nav.Medical.BM.BillingManagement
                },
                component: MedicalComponent,
                children: [
                    {
                        path: 'contracting-management',
                        name: 'contracting-management',
                        meta: {
                            title: translation[lang].Nav.Medical.BM.ContractingManagement
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'beneficiary-type',
                                name: 'app.BillingManagement.ContractingManagement.BeneficiaryType',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.BeneficiaryTypePage,
                                },
                            },  // Beneficiary Type
                            {
                                path: 'contract-category',
                                name: 'app.BillingManagement.ContractingManagement.ContractCategory',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.ContractCategoryPage,
                                },
                            },  // Contract Category
                            {
                                path: 'contractors-list',
                                name: 'app.BillingManagement.ContractingManagement.ContractorsList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.ContractorsListPage,
                                },
                            },  // Contractors List
                            {
                                path: 'contracts-list',
                                name: 'app.BillingManagement.ContractingManagement.ContractsList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.ContractsListGridHead,
                                },
                            },  // Contracts List
                            {
                                path: 'covering-letters-list',
                                name: 'app.BillingManagement.ContractingManagement.CoveringLettersList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.CoveringLettersListGridHead,
                                },
                            },  // Covering Letters List
                            {
                                path: 'visit-managment-simulation',
                                name: 'app.BillingManagement.ContractingManagement.VisitManagmentSimulation',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.VisitManagmentSimulation,
                                },
                            },  // VisitManagmentSimulation
                        ]
                    },   // Contracting Management
                    {
                        path: 'pricing-management',
                        name: 'pricing-management',
                        meta: {
                            title: translation[lang].Nav.Medical.BM.PricingManagement,
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'billing-groups-list',
                                name: 'app.BillingManagement.PricingManagement.BillingGroupsList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.BillingGroupsListPage,
                                },
                            },  // Billing Groups List
                            {
                                path: 'billing-group-assignment',
                                name: 'app.BillingManagement.PricingManagement.BillingGroupAssignment',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.BillingGroupAssignmentPage,
                                },
                            },  // Billing Group Assignment
                            {
                                path: 'services-price-lists',
                                name: 'app.BillingManagement.PricingManagement.ServicesPriceLists',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.ServicesPriceListsGridHead,
                                },
                            },  // Services Price Lists
                            {
                                path: 'items-price-lists',
                                name: 'app.BillingManagement.PricingManagement.ItemsPriceLists',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.ItemsPriceListsGridHead,
                                },
                            },  // Items Price Lists
                            {
                                path: 'price-inquiry',
                                name: 'app.BillingManagement.PricingManagement.PriceInquiry',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.PriceInquiryPage,
                                },
                            },  // Price Inquiry
                            {
                                path: 'barcode-pricing-config',
                                name: 'app.BillingManagement.PricingManagement.BarcodePricingConfig',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.BarcodePricingConfig,
                                },
                            },  // Barcode Pricing Config
                            {
                                path: 'barcode-manual-pricing',
                                name: 'app.BillingManagement.PricingManagement.BarcodeManualPricing',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.BarcodeManualPricing,
                                },
                            },  // Barcode Manual Pricing
                            {
                                path: 'packages-list',
                                name: 'app.BillingManagement.PricingManagement.PackagesList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.OffersAndPackageList
                                },
                            },  // Packages List
                        ]
                    }, // Pricing Management
                    {
                        path: 'suspending-schedules',
                        name: 'suspending-schedules',
                        meta: {
                            title: translation[lang].Nav.Medical.BM.SuspendingSchedules,
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'suspended-patients-list',
                                name: 'app.BillingManagement.SuspendingSchedules.SuspendedPatientsList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.SuspendedPatientsListPage,
                                },
                            },  // Suspended Patients List
                            {
                                path: 'suspended-contractors-list',
                                name: 'app.BillingManagement.SuspendingSchedules.SuspendedContractorsList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.SuspendedContractorsListPage,
                                },
                            },  // Suspended Contractors List
                            {
                                path: 'suspended-contracts-list',
                                name: 'app.BillingManagement.SuspendingSchedules.SuspendedContractsList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.SuspendedContractsListPage,
                                },
                            },  // Suspended Contracts List
                            {
                                path: 'suspended-contractor-clients-list',
                                name: 'app.BillingManagement.SuspendingSchedules.SuspendedContractorClientsList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.SuspendedContractorClientsListPage,
                                },
                            } // Suspended Contractor Clients List
                        ]
                    }, // Suspending Schedules
                    {
                        path: 'billing-configurations',
                        name: 'billing-configurations',
                        meta: {
                            title: translation[lang].Nav.Medical.BM.BillingfonfigurationsPage,
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'billing-configurations',
                                name: 'app.BillingManagement.BillingConfigurations',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.BillingConfigurationsPage,
                                },
                            }  // Billing Configurations
                        ]
                    }, // Billing Configurations
                    {
                        path: 'tax-setup',
                        name: 'tax-setup',
                        meta: {
                            title: translation[lang].Nav.Medical.BM.TaxSetup,
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'taxes-list',
                                name: 'app.BillingManagement.TaxSetup.TaxesList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.BM.TaxList,
                                },
                            }  // Taxes List
                        ]
                    }, // Tax Setup
                ]
            },   // Billing Management
            {
                path: 'emergency-room',
                name: 'emergency-room',
                meta: {
                    //title: translation[lang].Nav.Finance.GL
                    title: 'Emergency Room'
                },
                component: MedicalComponent,
                children: [
                    {
                        path: 'triage-management',
                        name: 'triage-management',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: 'Triage Management'
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'er-dashboard',
                                name: 'app.EmergencyRoom.TriageManagement.ERDashboard',
                                component: MedicalComponent,
                                meta: {
                                    title: 'ER Dashboard',
                                },
                            },  // ER Dashboard
                            {
                                path: 'er-patient-list',
                                name: 'app.EmergencyRoom.TriageManagement.ERPatientList',
                                component: MedicalComponent,
                                meta: {
                                    title: 'ER Patient List',
                                },
                            },  // ER Patient List
                        ]
                    },
                ]
            },   // Emergency Room
            {
                path: 'lab-rad',
                name: 'lab-rad',
                meta: {
                    title: translation[lang].Nav.LabRad.LabRadmodule
                },
                component: MedicalComponent,
                children: [
                    {
                        path: 'receive-orders',
                        name: 'receive-orders',
                        meta: {
                            title: translation[lang].Nav.LabRad.ReceiveOrders
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'receive-lab-orders',
                                name: 'app.LabRad.ReceiveOrders.ReceiveLabOrders',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.LabRad.ReceiveLabOrders,
                                },
                            },  // Receive Lab Orders
                            {
                                path: 'receive-mi-orders',
                                name: 'app.LabRad.ReceiveOrders.ReceiveRadOrders',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.LabRad.ReceiveMIOrders,
                                },
                            }, // Receive Rad Orders
                            {
                                path: 'receive-cis-orders', 
                                name: 'app.LabRad.ReceiveOrders.ReceiveCISOrders',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.LabRad.ReceiveCISOrders,
                                },
                            },  // Receive Lab Orders
                        ]
                    }, // Receive Orders
                    {
                        path: 'lab-setup',
                        name: 'lab-setup',
                        meta: {
                            title: translation[lang].Nav.LabRad.LabRadSetup,
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'components-management',
                                name: 'app.LabRad.LabSetup.ComponentsManagement',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.LabRad.ComponentsManagement,
                                },
                            },  // Components Management
                            {
                                path: 'template-management',
                                name: 'app.LabRad.LabSetup.TemplateManagement',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.LabRad.TemplateManagement,
                                },
                            } // Template Management
                        ]
                    } ,// Lab Setup
                        {
                        path: 'microbiology-setup',
                        name: 'app.LabRad.MicrobiologySetup.MicrobiologySetup',
                        meta: {
                            title: translation[lang].Nav.Microbiology.MicrobiologySetup,
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'micro-investigation-management',
                                name: 'app.LabRad.MicrobiologySetup.MicrobiologyInvestigationManagement',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Microbiology.MicrobiologyInvestigationManagment,
                                },
                            },  // Micro invbest management
                        ]
                    }, // Microbiology
                ]
            },   // Lab Rad
            {
                path: 'master-patient-index',
                name: 'master-patient-index',
                meta: {
                    //title: translation[lang].Nav.Finance.GL
                    title: translation[lang].Nav.Medical.MPI.MasterPatientIndex
                },
                component: MedicalComponent,//AppMedicalRecords,
                children: [
                    {
                        path: 'patient-demographics',
                        name: 'patient-demographics',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: translation[lang].Nav.Medical.MPI.PatientDemographics
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'register-new-patient',
                                name: 'app.MasterPatientIndex.PatientDemographics.RegisterNewPatient',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.MPI.RegisterNewPatient
                                },
                            },  // Register New Patient
                            {
                                path: 'find-patient',
                                name: 'app.MasterPatientIndex.PatientDemographics.FindPatient',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.MPI.FindPatient
                                },
                            },  // Find Patient
                            {
                                path: 'patient-merge',
                                name: 'app.MasterPatientIndex.PatientDemographics.PatientMerge',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.MPI.PatientMerge
                                },
                            },  // Patient Merge
                            {
                                path: 'new-patient-merge',
                                name: 'app.MasterPatientIndex.PatientDemographics.NewPatientMerge',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.MPI.NewPatientMerge
                                },
                            },  // New Patient Merge
                        ]
                    }
                ]
            },   // Master Patient Index
            {
                path: 'medical-setup',
                name: 'medical-setup',
                meta: {
                    //title: translation[lang].Nav.Finance.GL
                    title: 'Medical Setup'
                },
                component: MedicalComponent,
                children: [
                    {
                        path: 'health-care-provider',
                        name: 'health-care-provider',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: 'Health Care Provider'
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'physicians-list',
                                name: 'app.MedicalSetup.HealthCareProvider.PhysiciansList',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Physicians List',
                                },
                            },  // Physicians List
                        ]
                    }
                ]
            },   // Medical Setup
            {
                path: 'operation-theatre',
                name: 'operation-theatre',
                meta: {
                    title: translation[lang].Nav.OperationTheatre.OperationTheatre
                },
                component: MedicalComponent,
                children: [
                    {
                        path: 'manage-reservations',
                        name: 'manage-reservations',
                        meta: {
                            title: translation[lang].Nav.OperationTheatre.ManageReservations
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'operation-booking',
                                name: 'app.OperationTheatre.OperationRoomBooking.OperationBooking',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.OperationTheatre.ManageReservations
                                },
                            } // Operation Booking
                        ]
                    }, // Manage Reservations
                    {
                        path: 'operation-management',
                        name: 'operation-management',
                        meta: {
                            title: translation[lang].Nav.OperationTheatre.OperationManagement
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'operation-setup',
                                name: 'app.OperationTheatre.OperationManagement.OperationSetup',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.OperationTheatre.OperationSetup
                                },
                            } // Operation Setup
                        ]
                    } // Operation Management
                ]
            },   // Operation Theatre
            {
                path: 'outpatient',
                name: 'outpatient',
                meta: {
                    //title: translation[lang].Nav.Finance.GL
                    title: translation[lang].Nav.Outpatient.Outpatient
                },
                component: MedicalComponent,
                children: [
                    {
                        path: 'outpatient-setup',
                        name: 'outpatient-setup',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: translation[lang].Nav.Outpatient.OutpatientSetup
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'clinic-tag-list',
                                name: 'app.Outpatient.OutpatientSetup.ClinicTagList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Outpatient.ClinicTagLists,
                                },
                            },  // Clinic Tag List
                            {
                                path: 'physician-schedule-list',
                                name: 'app.Outpatient.OutpatientSetup.PhysicianScheduleList',
                                component: MedicalComponent,
                                meta: {                                   
                                    title: translation[lang].Nav.Outpatient.PhysicianScheduleList,
                                },
                            } // Physician Schedule List
                        ]
                    }, // Outpatient Setup
                    {
                        path: 'outpatient-reservation',
                        name: 'outpatient-reservation',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup                            
                            title: translation[lang].Nav.Outpatient.OutpatientReservation
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'appointment-booking',
                                name: 'app.Outpatient.OutpatientReservation.AppointmentBooking',
                                component: MedicalComponent,
                                meta: {                                  
                                    title: translation[lang].Nav.Outpatient.AppointmentBooking,
                                },
                            }  // Appointment Booking
                        ]
                    }, // Outpatient Reservation
                    {
                        path: 'outpatient-management',
                        name: 'outpatient-management',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup                            
                            title: translation[lang].Nav.Outpatient.OutpatientManagement
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'clinic-management',
                                name: 'app.Outpatient.OutpatientManagement.ClinicManagement',
                                component: MedicalComponent,
                                meta: {                                   
                                    title: translation[lang].Nav.Outpatient.ClinicManagement,
                                },
                            }  // Clinic Management
                        ]
                    }, // Outpatient Management
                ]
            },   // outpatient
            {
                path: 'product-management',
                name: 'product-management',
                meta: {
                    title: translation[lang].Nav.Medical.PM.ProductManagement,
                },
                component: MedicalComponent,
                children: [
                    {
                        path: 'medication-setup',
                        name: 'medication-setup',
                        meta: {
                            title: translation[lang].Nav.Medical.PM.MedicationSetup,
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'dosage-form',
                                name: 'app.ProductManagement.MedicationSetup.DosageForm',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.PM.DosageFormHead,
                                },
                            },// Dosage Form
                            {
                                path: 'strength-unit',
                                name: 'app.ProductManagement.MedicationSetup.StrengthUnit',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.PM.StrengthUnitHead,
                                },
                            },  // Strength Unit
                            {
                                path: 'therapeutic-category',
                                name: 'app.ProductManagement.MedicationSetup.TherapeuticCategory',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.PM.TherapeuticCategoryHead,
                                },
                            },  // Therapeutic Category
                            {
                                path: 'active-ingredient',
                                name: 'app.ProductManagement.MedicationSetup.ActiveIngredients',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.PM.ActiveIngredientsHead,
                                },
                            },  // Active Ingredients
                            {
                                path: 'medication-list',
                                name: 'app.ProductManagement.MedicationSetup.MedicationList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.PM.MedicationListHead,
                                },
                            }// Medication List
                        ]
                    }   // Medication Setup
                ]
            },   // Product Management
            {
                path: 'reports',
                name: 'reports',
                meta: {
                    title: translation[lang].Nav.Medical.Reports.Reports
                },
                component: MedicalComponent,
                children: [
                    {
                        path: 'visit-managment-reports',
                        name: 'visit-managment-reports',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: 'Visit Managment Reports'
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'refund-report',
                                name: 'app.Reports.ReportSubModule.RefundReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Refund Report',
                                },
                            },  // Refund Report
                            {
                                path: 'external-eclaim-publish',
                                name: 'app.Reports.ReportSubModule.ExternalEClaimPublish',
                                component: MedicalComponent,
                                meta: {
                                    title: 'External EClaim Publish Report',
                                },
                            },  // External Eclaim Report
                            {
                                path: 'visit-discount-report',
                                name: 'app.Reports.ReportSubModule.VisitDiscountReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Visit Discount Report',
                                },
                            },  // Visit Discount Report
                            {
                                path: 'visits-incident-count-report',
                                name: 'app.Reports.ReportSubModule.VisitsIncidentCountReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Visits Incident Count Report',
                                },
                            },  // Visits Incident Count Report
                            {
                                path: 'cancelled-transactions-report',
                                name: 'app.Reports.ReportSubModule.CancelledTransactionsReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Cancelled Transactions Report',
                                },
                            },  // Cancelled Transactions Report
                            {
                                path: 'doctor-bonus',
                                name: 'app.Reports.ReportSubModule.DoctorBonus',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Doctor Bonus',
                                },
                            },  // Doctor Bonus
                            {
                                path: 'not-confirmed-transactions-report',
                                name: 'app.Reports.ReportSubModule.NotConfirmedTransactionsReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Not Confirmed Transactions Report',
                                },
                            },  // Not Confirmed Transactions Report
                            {
                                path: 'journals-report',
                                name: 'app.Reports.ReportSubModule.JournalsReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Journals Report',
                                },
                            },  // Journals Report
                            {
                                path: 'invoice',
                                name: 'app.Reports.ReportSubModule.Invoice',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Invoice',
                                },
                            },  // Invoice
                            {
                                path: 'invoice-clamed',
                                name: 'app.Reports.ReportSubModule.Invoice_Clamed',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Invoice Clamed',
                                },
                            },  // Invoice Clamed
                            {
                                path: 'or-list-report',
                                name: 'app.Reports.ReportSubModule.ORListReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'OR List Report',
                                },
                            },  // OR List Report
                            {
                                path: 'inpatient-list-report',
                                name: 'app.Reports.ReportSubModule.InpatientListReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Inpatient List Report',
                                },
                            },  // Inpatient List Report
                            {
                                path: 'aac-statistics',
                                name: 'app.Reports.ReportSubModule.AAC_Statistics',
                                component: MedicalComponent,
                                meta: {
                                    title: 'AAC Statistics',
                                },
                            },  // AAC Statistics
                            {
                                path: 'aac-statistic-summary',
                                name: 'app.Reports.ReportSubModule.AAC_Statistic_Summary',
                                component: MedicalComponent,
                                meta: {
                                    title: 'AAC Statistic Summary',
                                },
                            },  // AAC Statistic Summary
                            {
                                path: 'pharmcy-return',
                                name: 'app.Reports.ReportSubModule.PharmcyReturn',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Pharmcy Return',
                                },
                            },  // Pharmcy Return
                            {
                                path: 'cl-payment-report',
                                name: 'app.Reports.ReportSubModule.CLPaymentReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'CL Payment Report',
                                },
                            },  // CL Payment Report
                            {
                                path: 'discharged-inpatient-visits-report',
                                name: 'app.Reports.ReportSubModule.DischargedInpatientVisitsReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Discharged Inpatient Visits Report',
                                },
                            },  // Discharged Inpatient Visits Report
                            {
                                path: 'treating-doctor-report',
                                name: 'app.Reports.ReportSubModule.TreatingDoctorReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Treating Doctor Report',
                                },
                            },  // Treating Doctor Report

                            {
                                path: 'productivity-report',
                                name: 'app.Reports.ReportSubModule.ProductivityReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Productivity Report',
                                },
                            },  // Productivity Report
                            {
                                path: 'er-patients-balance',
                                name: 'app.Reports.ReportSubModule.ERPatientsBalance',
                                component: MedicalComponent,
                                meta: {
                                    title: 'ER Patients Balance',
                                },
                            },  // ER Patients Balance
                            {
                                path: 'patient-financial-status',
                                name: 'app.Reports.ReportSubModule.PatientFinancialStatus',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Patient Financial Status',
                                },
                            },  // Patient Financial Status

                            {
                                path: 'status-log',
                                name: 'app.Reports.ReportSubModule.VisitContractsStatusLog',
                                component: MedicalComponent,
                                meta: {
                                    title: 'visitsContractsStatusLog',
                                },
                            },
                            {
                                path: 'authorization-statusLog-report',
                                name: 'app.Reports.ReportSubModule.AuthorizationStatusLogReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Authorization Status Log',
                                },
                            },
                            {
                                path: 'package-consumption-report',
                                name: 'app.Reports.ReportSubModule.PackagesConsumptionReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Package Consumption Report',
                                },
                            },
                            {
                                path: 'InPatient-discharge-list-report',
                                name: 'app.Reports.ReportSubModule.PatientDischargeListReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'InPatient Discharge List Report',
                                },
                            },
                            {
                                path: 'visits-for-specific-consultant-report',
                                name: 'app.Reports.ReportSubModule.VisitsForSpecificConsultantReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Visits For Specific Consultant Report',
                                },
                            },
                            {
                                path: 'visits-for-specific-contractor-report',
                                name: 'app.Reports.ReportSubModule.VisitsForSpecificContractorReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Visits For Specific Contractor Report',
                                },
                            },

                            {
                                path: 'unbalanced-visits-report',
                                name: 'app.Reports.ReportSubModule.UnbalancedVisits',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Unbalanced Visits Report',
                                },
                            },
                            {
                                path: 'DownPaymentsList',
                                name: 'app.Reports.ReportSubModule.DownPaymentsList',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Down Payments List',
                                },
                            },
                            {
                                path: 'open-statement-report',
                                name: 'app.Reports.ReportSubModule.OpenStatementReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Open Statement Report',
                                },
                            },
                            {
                                path: 'unbilled-report',
                                name: 'app.Reports.ReportSubModule.UnbilledReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'unbilled Report',
                                },
                            },
                            {
                                path: 'contractor-activity-report',
                                name: 'app.Reports.ReportSubModule.ContractorActivityReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Contractor Activity Report',
                                },
                            },
                            {
                                path: 'approval-status-report',
                                name: 'app.Reports.ReportSubModule.ApprovalStatusReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Approval Status Report',
                                },
                            },
                            {
                                path: 'notClaimed-contractors-report',
                                name: 'app.Reports.ReportSubModule.NotClaimedContractorsReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Not Claimed Contractors Report',
                                },
                            }
                        ]
                    },   // Visit Managment Reports
                    {
                        path: 'outpatient-reports',
                        name: 'outpatient-reports',
                        meta: {
                            title: translation[lang].Nav.Reports.OutpatientReports
                           // title: 'Outpatient Reports'
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'call-center',
                                name: 'app.Reports.OutpatientReports.CallCenter',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Call Center',
                                },
                            },  // Call Center
                            {
                                path: 'outpatient-registration',
                                name: 'app.Reports.OutpatientReports.OutpatientRegistration',
                                component: MedicalComponent,
                                meta: {
                                    //title: 'Outpatient Registration',
                                    title: translation[lang].Nav.Reports.OutpatientRegistration
                                },
                            },  // Outpatient Registeration
                            {
                                path: 'not-confirmed',
                                name: 'app.Reports.OutpatientReports.NotConfirmed',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Not Confirmed',
                                },
                            },  // Not Confirmed
                            {
                                path: 'call-center-agent-analysis',
                                name: 'app.Reports.OutpatientReports.CallCenterAgentAnalysis',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Call Center Agent Analysis',
                                },
                            },  // Call Center Agent Analysis
                            {
                                path: 'nearest-appointment-date-for-clinics',
                                name: 'app.Reports.OutpatientReports.NearestAppointmentDateForClinics',
                                component: MedicalComponent,
                                meta: {
                                    title: 'NearestAppointmentDateForClinics',
                                },
                            }, // NearestAppointmentDateForClinics
                            {
                                path: 'transfer-referral-report',
                                name: 'app.Reports.OutpatientReports.ReferralClinicalTransfer',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Transfer & Referral Orders',
                                },
                            }

                        ]
                    }, // Outpatient Reports
                    {
                        path: 'Billing Reports',
                        name: 'suspending-schedules',
                        meta: {
                            title: translation[lang].Nav.Medical.Reports.BillingReportsHead
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'basic-claim-report',
                                name: 'app.Reports.ReportSubModule.BasicClaimReport',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Reports.BillingReports.BasicClaimReport
                                },
                            },  // Basic Claim Report
                            {
                                path: 'detailed-claims-report',
                                name: 'app.Reports.ReportSubModule.DetailedClaimsReport',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Reports.BillingReports.DetailedClaimReport
                                },
                            },  // Detailed Claims Report
                            {
                                path: 'prices-report',
                                name: 'app.Reports.ReportSubModule.PricesReport',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Reports.BillingReports.PriceComparisonReport
                                },
                            },  // Prices Report
                            {
                                path: 'invoice-summary-report',
                                name: 'app.Reports.ReportSubModule.InvoiceSummaryReport',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Reports.BillingReports.InvoiceSummaryReport
                                },
                            } // Invoice Summary Report
                        ]
                    }, // Billing Reports
                    {
                        path: 'lab-rad-reports',
                        name: 'lab-rad-reports',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: 'Lab and MI Reports'
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'patient-services',
                                name: 'app.Reports.ReportSubModule.PatientServices',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Patient Services',
                                },
                            },  // PatientServices
                            {
                                path: 'Waiting-Time',
                                name: 'app.Reports.ReportSubModule.WaitingTime',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Waiting Time',
                                },
                            },

                        ]
                    }, // Lab and MI Reports
                    {
                        path: 'er-reports',
                        name: 'er-reports',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: 'ER Reports'
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'left-unseen-report',
                                name: 'app.Reports.ReportSubModule.LeftUnseenReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Left Unseen Report',
                                },
                            }, // Left Unseen Report
                            {
                                path: 'inPatient-report',
                                name: 'app.Reports.ReportSubModule.InPatientReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'InPatient Report',
                                },
                            } // InPatient Report
                        ]
                    }, // ER Reports
                    {
                        path: 'patient-prognosis-reports',
                        name: 'patient-prognosis-reports',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: 'Patient Prognosis Reports'
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'patient-problem-history-report',
                                name: 'app.Reports.ReportSubModule.PatientProblemHistoryReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Patient Problem History Report',
                                },
                            }, // Patient Problem History Report
                            {
                                path: 'medical-protocol-report',
                                name: 'app.Reports.ReportSubModule.MedicalProtocolReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Medical Protocol Report',
                                },
                            } // Medical Protocol Report
                        ]
                    } // Patient Prognosis Reports
                ]
            },   // Reports
            {
                path: 'Pharmacy-Reports',
                name: 'Pharmacy-Reports',
                meta: {
                    title: translation[lang].Nav.Medical.Vm.PharmacyReports
                },
                component: MedicalComponent,
                children: [
                    {
                        path: 'Pharmacy-Sales-Report',
                        name: 'Pharmacy-Sales-Report',
                        meta:{ 
                            title: 'Pharmacy Reports'
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'Pharmacy-Sales-Report',
                                name: 'app.Reports.ReportSubModule.PharmacySalesReport',
                                component: MedicalComponent,
                                meta: {
                                    title: 'Pharmacy Sales Report',
                                },
                            }
                        ]
                    },
                ]
            }, //Pharmacy Reports
            {
                path: 'visits-management',
                name: 'visits-management',
                meta: {
                    //title: translation[lang].Nav.Finance.GL
                    title: translation[lang].Nav.Medical.Vm.VisitManagement
                },
                component: MedicalComponent,
                children: [
                    {
                        path: 'visit-management',
                        name: 'visit-management',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: translation[lang].Nav.Medical.Vm.VisitManagement
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'visit-management',
                                name: 'app.VisitManagement.VisitManagement.VisitManagement',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.VisitManagement,
                                },
                            },// Visit Management
                            {
                                path: 'visit-actions',
                                name: 'app.VisitManagement.VisitManagement.VisitActions',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.VisitAction,
                                },
                            },  // Visit Actions
                            {
                                path: 'visits-history',
                                name: 'app.VisitManagement.VisitManagement.VisitsHistory',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.VisitHistory,
                                },
                            }, // Visits History
                            {
                                path: 'contract-assignments',
                                name: 'app.VisitManagement.VisitManagement.ContractAssignments',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.ContractAssignments,
                                },
                            }, // ContractAssignments
                            {
                                path: 'treatment-plan',
                                name: 'app.VisitManagement.VisitManagement.TreatmentPlan',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.TreatmentPlan,
                                },
                            },
                        ]
                    },  // Visit Management
                    {
                        path: 'assignments',
                        name: 'assignments',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: translation[lang].Nav.Medical.Vm.Assignments
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'cashpoint-assignment-list',
                                name: 'app.VisitManagement.VisitManagement.CashierAssignments.CashPointAssignmentList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.CashpointAssignmentList,
                                },
                            },// Cashpoint Assignmen tList
                            {
                                path: 'warehouse-assignments-list',
                                name: 'app.VisitManagement.VisitManagement.CashierAssignments.WarehouseAssignmentsList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.WareHouseAssignmentList,
                                },
                            },  // Warehouse Assignments List
                            {
                                path: 'nurse-assignments-list',
                                name: 'app.VisitManagement.VisitManagement.CashierAssignments.NurseAssignmentsList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.NurseAssignmentList,
                                },
                            }, // Nurse Assignments List
                            {
                                path: 'discount-rules-setup',
                                name: 'app.VisitManagement.VisitManagement.CashierAssignments.DiscountRuleSetup',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.DiscountRulesSetup,
                                },
                            }, // discount rule setup

                            //wasele config screen
                            {
                                path: 'wasele-configuration',
                                name: 'app.VisitManagement.VisitManagement.CashierAssignments.WaseleConfiguration',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.WaseleConfiguration,
                                },
                            },
                            // ...ItemsOfServicesRouter 
                            {
                                path: 'items-of-service-list',
                                name: 'app.VisitManagement.VisitManagement.CashierAssignments.ItemsOfServices.ItemsOfServicesList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.ItemsOfServices,
                                },
                                children: [
                                    /* {
                                        path: 'mini-packages-list',
                                        name: 'app.VisitManagement.VisitManagement.CashierAssignments.ItemsOfServices.ItemsOfServicesList',
                                        component: MedicalComponent,
                                        meta: {
                                            title: translation[lang].Nav.Medical.Vm.ItemsOfServicesList,
                                        },
                                    },  */
                                    {
                                        path: 'items-of-service-save',
                                        name: 'app.VisitManagement.VisitManagement.CashierAssignments.ItemsOfServices.ItemsOfServicesSave',
                                        component: MedicalComponent,
                                        meta: {
                                            title: translation[lang].Nav.Medical.Vm.NewItemsOfServices,
                                        },
                                    },
                                    {
                                        path: 'items-of-service-edit',
                                        name: 'app.VisitManagement.VisitManagement.CashierAssignments.ItemsOfServices.ItemsOfServicesEdit',
                                        component: MedicalComponent,
                                        meta: {
                                            title: translation[lang].Nav.Medical.Vm.EditItemsOfServices,
                                        },
                                    }
                                ]
                            },
                        ]
                    },  // Assignments
                    {
                        path: 'pharmacy',
                        name: 'pharmacy',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: translation[lang].Nav.Medical.Vm.Pharmacy
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'dispense-transactions',
                                name: 'app.VisitManagement.Pharmacy.DispenseTransactions',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.DispenseTransactions,
                                },
                            }, // Dispense Transactions
                            {
                                path: 'iv-preparation',
                                name: 'app.VisitManagement.Pharmacy.IvPreparation',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.DispenseTransactions,
                                },
                            }
                        ]
                    },  // Pharmacy
                    {
                        path: 'authorization',
                        name: 'authorization',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: translation[lang].Nav.Medical.Vm.Authorization
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'authorization',
                                name: 'app.VisitManagement.VisitManagement.Authorization',
                                component: MedicalComponent,
                                meta: {

                                    title: translation[lang].Nav.Medical.Vm.Authorization,
                                },
                                
                                
                            },// Authorization
                            {
                                path: 'ipdAuthorization',
                                name: 'app.VisitManagement.VisitManagement.IpdAuthorization',
                                component: MedicalComponent,
                                meta: {

                                    title: translation[lang].Nav.Medical.Vm.IpdAuthorization,
                                },
                                children: [
                                    {
                                        path: 'admission-request',
                                        name: 'app.VisitManagement.VisitManagement.IpdAuthorization.AdmissionRequest',
                                        component: MedicalComponent,
                                        meta: {

                                            title: translation[lang].Nav.Medical.Vm.AdmissionRequest,
                                        },
                                        children: [
                                            {
                                                path: 'view-admission-request-details',
                                                name: 'app.VisitManagement.VisitManagement.IpdAuthorization.AdmissionRequest.ViewAdmissionRequestDetails',
                                                component: MedicalComponent,
                                                meta: {

                                                    title: translation[lang].Nav.Medical.Vm.ViewAdmissionRequestDetails,
                                                },

                                            }
                                        ]
                                    },
                                ]
                   
                            },
                            
                            {
                                path: 'check-eligibility',
                                name: 'app.VisitManagement.VisitManagement.CheckEligibility',
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.CheckEligibility,
                                },
                                component: MedicalComponent
                            },
                        ]
                    },  // Authorization

                    //{
                    //    path: 'IpdAuthorization',
                    //    name: 'IpdAuthorization',
                    //    meta: {
                    //        //title: translation[lang].Nav.Finance.GLSetup
                    //        title: 'IpdAuthorization'
                    //    },
                    //    component: MedicalComponent,
                    //    children: [
                    //        {
                    //            path: 'IpdAuthorization',
                    //            name: 'app.VisitManagement.VisitManagement.IpdAuthorization',
                    //            component: MedicalComponent,
                    //            meta: {

                    //                title: translation[lang].Nav.Medical.Vm.IpdAuthorization,
                    //            },
                    //        } // Authorization
                    //    ]
                    //},  // Authorization
                    {
                        path: 'claim-management',
                        name: 'claim-management',
                        meta: {
                            //title: translation[lang].Nav.Finance.GLSetup
                            title: translation[lang].Nav.Medical.Vm.ClaimManagement,
                        },
                        component: MedicalComponent,
                        children: [
                            {
                                path: 'statement-list',
                                name: 'app.VisitManagement.ClaimManagement.StatmentList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.StatementList,
                                },
                            }, // Statment List
                            {
                                path: 'contractor-statement-list',
                                name: 'app.VisitManagement.ClaimManagement.ContractorStatementList',
                                component: MedicalComponent,
                                meta: {
                                    title: translation[lang].Nav.Medical.Vm.ContractorStatementList,
                                },
                                children: [
                                    {
                                        path: 'contractor-statement-bulk-actions',
                                        name: 'app.VisitManagement.ClaimManagement.StatmentList.ContractorStatementBulkActions',
                                        component: MedicalComponent,
                                        meta: {
                                            title: translation[lang].Nav.Medical.Vm.ContractorStatementBulkActions,
                                        },
                                    }, // Statment List

                                ]
                            }, // Contractor Statement List
                        ]
                    },  // Claim Management
                ]
            },   // Visits Management
        ],
        beforeEnter: guardRoute
    }   // Medical Routes

];

export default medicalRoutes;